import React from 'react';

import MyButton from '../button/Button';
import './disable-warning.scss';

interface DisableSwitchWarningProperties {
  selectedId?: string | null;
  onCancel: () => void;
  message: JSX.Element | string;
  onConfirm: (selectId?: string | null) => void;
  cancelLabel?: string;
  confirmLabel?: string;
}
/**
 * A warning modal that prompts the user before disabling.
 * @param {any} properties properties
 * @returns {any} The rendered component.
 */
function DisableSwitchWarning(properties: DisableSwitchWarningProperties) {
  const { selectedId, message, onCancel, cancelLabel, confirmLabel, onConfirm } = properties;
  return (
    <div className="disable-warning-wrap">
      <div className="disable-waring-content">
        <h1>Warning ⚠️</h1>
        <p>
          <span>{message}</span>
        </p>
      </div>
      <div className="disable-button">
        <MyButton
          label={cancelLabel || 'Cancel'}
          buttonType="back"
          onClickFunc={onCancel}
          disableHoverEffect
        />
        <MyButton
          label={confirmLabel || 'OK'}
          buttonType="warning"
          onClickFunc={() => onConfirm(selectedId)}
        />
      </div>
    </div>
  );
}

DisableSwitchWarning.defaultProps = {
  selectedId: null,
  confirmLabel: '',
  cancelLabel: '',
};

export default DisableSwitchWarning;
